import { toUpper } from 'lodash'

export const getFirstAlpha = (str?: string) => {
  return str ? toUpper(str[0]) : ''
}
